import React from 'react'
import { Link } from 'react-router-dom'
import { DocumentTextIcon, ArrowRightIcon } from '@heroicons/react/24/outline'

const Landing: React.FC = () => {
  return (
    <main className="py-20 sm:py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl">
          {/* Hero Section */}
          <div className="text-center mb-24 sm:mb-32">
            <h1 className="text-4xl font-bold tracking-tight text-brand-black sm:text-5xl font-['Arial']">
              Help AI understand your website
            </h1>
            <p className="mt-8 text-lg leading-8 text-neutral-500 max-w-2xl mx-auto">
              Create and validate your llms.txt file to control how AI models interact with your content
            </p>
            <div className="mt-12 flex items-center justify-center gap-x-6">
              <Link to="/generator" className="inline-flex items-center gap-x-2 px-5 py-3 text-sm font-semibold shadow-sm btn-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 transition-colors duration-200">
                Create Your llms.txt
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
              </Link>
              <Link
                to="/validator"
                className="text-sm font-semibold leading-6 text-brand-black hover:text-brand-black transition-colors duration-200"
              >
                Validate Existing File <span aria-hidden="true">→</span>
              </Link>
            </div>
          </div>

          {/* What is llms.txt Section */}
          <div className="mb-20 sm:mb-24">
            <div className="text-center mb-12">
              <h2 className="text-2xl font-bold tracking-tight text-brand-black sm:text-3xl font-['Arial']">
                What is llms.txt?
              </h2>
              <p className="mt-6 text-lg text-neutral-400 max-w-2xl mx-auto">
                A simple text file that helps AI models understand how to interact with your website
              </p>
            </div>

            <div className="grid grid-cols-1 gap-6 sm:gap-8 sm:grid-cols-3">
              <div className="bg-surface-light p-6 sm:p-8 rounded-lg hover:border hover:border-neutral-200 transition-colors duration-200">
                <h3 className="text-lg font-semibold text-brand-black mb-3">Control Training</h3>
                <p className="text-neutral-500">Specify whether AI models can use your content for training</p>
              </div>
              <div className="bg-surface-light p-6 sm:p-8 rounded-lg hover:border hover:border-neutral-200 transition-colors duration-200">
                <h3 className="text-lg font-semibold text-brand-black mb-3">Manage Crawling</h3>
                <p className="text-neutral-500">Control how AI models can crawl and index your website</p>
              </div>
              <div className="bg-surface-light p-6 sm:p-8 rounded-lg hover:border hover:border-neutral-200 transition-colors duration-200">
                <h3 className="text-lg font-semibold text-brand-black mb-3">Set Rules</h3>
                <p className="text-neutral-500">Define specific rules and conditions for AI interaction</p>
              </div>
            </div>
          </div>

          {/* Tools Section */}
          <div className="mb-20 sm:mb-24">
            <div className="text-center mb-12">
              <h2 className="text-2xl font-bold tracking-tight text-brand-black sm:text-3xl font-['Arial']">
                Our Tools
              </h2>
            </div>

            <div className="grid grid-cols-1 gap-6 sm:gap-8 sm:grid-cols-2">
              <div className="bg-surface-light p-6 sm:p-8 rounded-lg hover:border hover:border-neutral-200 transition-colors duration-200">
                <div className="flex items-center gap-4 mb-4">
                  <DocumentTextIcon className="h-8 w-8 text-brand-black" />
                  <h3 className="text-lg font-semibold text-brand-black">Generator</h3>
                </div>
                <p className="text-neutral-500 mb-6">Create a properly formatted llms.txt file for your website</p>
                <Link to="/generator" className="inline-flex items-center gap-x-2 text-brand-black hover:text-neutral-700 transition-colors duration-200">
                  Generate Now
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
                </Link>
              </div>
              <div className="bg-surface-light p-6 sm:p-8 rounded-lg hover:border hover:border-neutral-200 transition-colors duration-200">
                <div className="flex items-center gap-4 mb-4">
                  <DocumentTextIcon className="h-8 w-8 text-brand-black" />
                  <h3 className="text-lg font-semibold text-brand-black">Validator</h3>
                </div>
                <p className="text-neutral-500 mb-6">Validate your existing llms.txt file for errors and best practices</p>
                <Link to="/validator" className="inline-flex items-center gap-x-2 text-brand-black hover:text-neutral-700 transition-colors duration-200">
                  Validate Now
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default Landing 